import Component from 'flarum/common/Component';
import app from 'flarum/common/app';
export default class AdvancedAdminWidget extends Component {
  view(vnode) {
    const stats = app.forum.attribute('advancedAdminStats');
    if (!stats) return null;
    return m("div", {
      className: "AdvancedAdminWidget"
    }, m("div", {
      className: "AdvancedAdminWidget-title"
    }, m("i", {
      className: "fas fa-chart-line",
      style: {
        marginRight: '5px'
      }
    }), app.translator.trans('nagusi-advanced-admin.forum.widget.title')), m("div", {
      className: "AdvancedAdminWidget-cards"
    }, m("div", {
      className: "AdminStat-card"
    }, m("div", {
      className: "AdminStat-card-header"
    }, m("i", {
      className: "fas fa-users AdminStat-icon community"
    }), m("h4", null, app.translator.trans('nagusi-advanced-admin.forum.widget.group_community'))), m("div", {
      className: "AdminStat-card-body"
    }, m("div", {
      className: "AdminStat-row"
    }, m("span", null, app.translator.trans('nagusi-advanced-admin.forum.widget.users')), m("strong", null, stats.usersCount)), m("div", {
      className: "AdminStat-row"
    }, m("span", null, app.translator.trans('nagusi-advanced-admin.forum.widget.active_7d')), m("strong", null, stats.activeUsers7d)))), m("div", {
      className: "AdminStat-card"
    }, m("div", {
      className: "AdminStat-card-header"
    }, m("i", {
      className: "fas fa-file-alt AdminStat-icon content"
    }), m("h4", null, app.translator.trans('nagusi-advanced-admin.forum.widget.group_content'))), m("div", {
      className: "AdminStat-card-body"
    }, m("div", {
      className: "AdminStat-row"
    }, m("span", null, app.translator.trans('nagusi-advanced-admin.forum.widget.discussions')), m("strong", null, stats.discussionsCount)), m("div", {
      className: "AdminStat-row"
    }, m("span", null, app.translator.trans('nagusi-advanced-admin.forum.widget.posts')), m("strong", null, stats.postsCount)))), m("div", {
      className: "AdminStat-card interactions-card"
    }, m("div", {
      className: "AdminStat-card-header"
    }, m("i", {
      className: "fas fa-bolt AdminStat-icon interactions"
    }), m("h4", null, app.translator.trans('nagusi-advanced-admin.forum.widget.interactions_total'))), m("div", {
      className: "AdminStat-card-body"
    }, m("div", {
      className: "AdminStat-total"
    }, m("h3", null, stats.interactionsCount), m("p", null, app.translator.trans('nagusi-advanced-admin.forum.widget.interactions_detail'))), m("div", {
      className: "AdminStat-breakdown"
    }, m("span", {
      title: app.translator.trans('nagusi-advanced-admin.forum.widget.posts')
    }, m("i", {
      className: "fas fa-comment"
    }), " ", stats.postsCount), m("span", {
      title: app.translator.trans('nagusi-advanced-admin.forum.widget.likes')
    }, m("i", {
      className: "fas fa-thumbs-up"
    }), " ", stats.likesCount), m("span", {
      title: app.translator.trans('nagusi-advanced-admin.forum.widget.reactions')
    }, m("i", {
      className: "fas fa-smile"
    }), " ", stats.reactionsCount))))));
  }
}
flarum.reg.add('nagusi-match-ratings', 'forum/stats/AdvancedAdminWidget', AdvancedAdminWidget);